import { Component, inject } from '@angular/core';
import { FormControl, ReactiveFormsModule, Validators } from '@angular/forms';
import {
  MAT_DIALOG_DATA,
  MatDialogModule,
  MatDialogRef,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { TimeSeriesPivotTableDataService } from '@backoffice-frontend/controlling/domain';
import type { AddDialogParams } from '@clean-code/models';
import {
  convertUtcToLocalTimezoneDate,
  dateTimeNow,
} from '@clean-code/shared/common';
import { ActionButtonModule } from '@clean-code/shared/components/ui-action-button';
import dayjs from 'dayjs';
import { DxDateBoxModule } from 'devextreme-angular';
import { finalize, tap } from 'rxjs';
import { PivotTableFunctionsService } from '../../data/functions/pivot-table-functions.service';
import { PivotTableService } from '../../data/pivot-table.service';

@Component({
  selector: 'feature-pivot-table-add-cell-data-dialog',
  imports: [
    MatDialogModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,

    DxDateBoxModule,

    ActionButtonModule,
  ],
  templateUrl: './add-cell-data-dialog.component.html',
  styleUrls: ['./add-cell-data-dialog.component.scss'],
})
export class AddCellDataDialogComponent {
  public dialogParams: AddDialogParams = inject(MAT_DIALOG_DATA);
  public dialogRef = inject(MatDialogRef<AddCellDataDialogComponent>);
  protected pivotTableFunctionsService = inject(PivotTableFunctionsService);

  protected service: TimeSeriesPivotTableDataService = inject(
    TimeSeriesPivotTableDataService,
  );
  protected tableService: PivotTableService = inject(PivotTableService);

  columnName: string =
    this.pivotTableFunctionsService.columnNameToTranslationKey(
      this.dialogParams.columnName,
    );

  public cellFormControl = new FormControl(null, Validators.required);

  public timestampFormControl = new FormControl<Date | null>(
    dateTimeNow(),
    Validators.required,
  );

  constructor() {
    this.service
      .getTimeStamp$(
        this.dialogParams.position.columnSymbol,
        this.dialogParams.position.rowDate,
      )
      .pipe(
        tap((date: Date) => {
          this.timestampFormControl.setValue(date);
        }),
      )
      .subscribe();
  }

  public colName = this.dialogParams.columnName;

  title = `${this.dialogParams.position.columnSymbol}, ${dayjs(this.dialogParams.position.rowDate).format('YYYY-MM-DD')}`;

  addCellData() {
    const date = convertUtcToLocalTimezoneDate(
      this.dialogParams.position.rowDate,
    );
    const symbol = this.dialogParams.position.columnSymbol;
    const unit = this.dialogParams.position.unit;
    const value = this.cellFormControl.value;
    this.service
      .add$(
        this.colName,
        +value,
        date,
        symbol,
        unit,
        this.timestampFormControl.value,
      )
      .pipe(tap(() => this.tableService.setRefreshTable(true)))
      .pipe(finalize(() => this.dialogRef.close()))
      .subscribe();
  }
}
